export const {
  PUBLIC_URL,
  REACT_APP_API_BASE_URL,
  REACT_APP_BASE_URL,
  REACT_APP_ENVIRONMENT,
  REACT_APP_MERCADO_PUBLICO_BASE_URL,
  REACT_APP_TOKEN_FOR_TIENDA
} = process.env
export const isDevEnv = process.env.REACT_APP_ENVIRONMENT !== 'prod'
